export default "__VITE_ASSET__hqSycME2__"